import { render, staticRenderFns } from "./bookingFormatAddress.vue?vue&type=template&id=ce6039fc&scoped=true&"
import script from "./bookingFormatAddress.vue?vue&type=script&lang=js&"
export * from "./bookingFormatAddress.vue?vue&type=script&lang=js&"
import style0 from "./bookingFormatAddress.vue?vue&type=style&index=0&id=ce6039fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6039fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce6039fc')) {
      api.createRecord('ce6039fc', component.options)
    } else {
      api.reload('ce6039fc', component.options)
    }
    module.hot.accept("./bookingFormatAddress.vue?vue&type=template&id=ce6039fc&scoped=true&", function () {
      api.rerender('ce6039fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/prePlanBookingJc/bookingFormatAddress.vue"
export default component.exports